import React from "react"

// Components
import "./style.css"

const SmallSpacer = () => {
    return <div className="small-spacer" />
}

export default SmallSpacer



// WEBPACK FOOTER //
// ./src/components/SmallSpacer/index.js